import React from 'react';
import { QUESTIONS_FINAL, QUESTIONS_HEADLINE, ownerQuestions, questionsBody } from '../data/poolContent';
export function QuestionsSection() {
  return <section className="w-full border-y border-pool/15 bg-navy py-14 sm:py-20" aria-labelledby="questions-title" data-id="element-290" data-mp="2apg94lwbqtxq">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16" data-id="element-291" data-mp="21r49xvhe6nto">
        <div data-id="element-292" data-mp="1ws03hclur471">
          <h2 id="questions-title" className="font-display text-[2rem] font-bold uppercase leading-none text-frost-50 sm:text-[2.7rem]" data-id="element-293" data-mp="1wsjjgnrxziif">
            {QUESTIONS_HEADLINE}
          </h2>
          {questionsBody.map(line => <p key={line} className="mt-4 text-[15px] leading-relaxed text-frost-200" data-id="element-294" data-mp="1i2lsy16jigq2">
              {line}
            </p>)}
        </div>

        <ul className="flex flex-wrap content-start gap-2.5" data-id="element-295" data-mp="1dzp59w257uf9">
          {ownerQuestions.map(q => <li key={q} className="rounded-full border border-pool/30 bg-abyss-950/60 px-4 py-2.5 text-[13.5px] font-medium leading-snug text-frost-50" data-id="element-296" data-mp="192fhslybdsu2">
              {q}
            </li>)}
        </ul>
      </div>

      <p className="mx-auto mt-12 max-w-2xl px-5 text-center font-display text-[1.5rem] font-semibold uppercase leading-tight text-aqua sm:text-[1.9rem]" data-id="element-297" data-mp="hq56sf8znznm">
        {QUESTIONS_FINAL}
      </p>
    </section>;
}